export const initPicker = () => {
  const pickers = document.querySelectorAll('.picker');

  pickers.forEach((picker) => {
    const items = picker.querySelectorAll('.picker__item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        picker.querySelector('.picker__item.is-active').classList.remove('is-active');
        item.classList.add('is-active');
      });
    });
  });
};
